const TOOL_ALIASES = [
  {
    id: 'add_label_to_conversation',
    aliases: [
      'add_label_to_conversation',
      'add label to conversation',
      'agregar etiqueta a la conversacion',
      'agregar etiqueta a la conversación',
    ],
  },
  {
    id: 'add_contact_note',
    aliases: [
      'add_contact_note',
      'add contact note',
      'agregar nota al contacto',
    ],
  },
  {
    id: 'add_private_note',
    aliases: ['add_private_note', 'add private note', 'agregar nota privada'],
  },
  {
    id: 'resolve_conversation',
    aliases: [
      'resolve_conversation',
      'resolve conversation',
      'resolver conversacion',
      'resolver conversación',
    ],
  },
  {
    id: 'update_priority',
    aliases: ['update_priority', 'update priority', 'actualizar prioridad'],
  },
  {
    id: 'assign_agent',
    aliases: ['assign_agent', 'assign agent', 'asignar agente'],
  },
  {
    id: 'assign_team',
    aliases: ['assign_team', 'assign team', 'asignar equipo'],
  },
  {
    id: 'faq_lookup',
    aliases: ['faq_lookup', 'faq lookup', 'buscar pregunta frecuente'],
  },
  {
    id: 'handoff',
    aliases: ['handoff', 'handoff to human', 'derivar a un agente'],
  },
  {
    id: 'send_message',
    aliases: [
      'send_message',
      'send message',
      'enviar mensaje',
      'enviar mensagem',
    ],
  },
  {
    id: 'send_resource',
    aliases: [
      'send_resource',
      'send resource',
      'enviar recurso',
      'enviar archivo',
    ],
  },
];

const BOUNDARY = '(^|[^\\w/@])';
const AFTER = '(?=$|[^\\w-])';

const ALIAS_REPLACEMENTS = TOOL_ALIASES.flatMap(({ id, aliases }) =>
  aliases.map(alias => ({ id, alias }))
);

const escapeRegExp = value => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const linkPattern = () => /\[([^\]]*)\]\(tool:\/\/([a-z0-9_]+)\)/gi;

const replacementsFor = tools => {
  const titles = tools
    .filter(tool => tool?.id && tool.title)
    .map(tool => ({ id: tool.id, alias: String(tool.title).trim() }))
    .filter(item => item.alias);

  return [...ALIAS_REPLACEMENTS, ...titles].sort(
    (left, right) => right.alias.length - left.alias.length
  );
};

const parkLinks = text => {
  const tokens = [];
  const parked = text.replace(linkPattern(), match => {
    tokens.push(match);
    return `\0${tokens.length - 1}\0`;
  });
  return { parked, tokens };
};

const unparkLinks = (text, tokens) =>
  text.replace(/\0(\d+)\0/g, (_, index) => tokens[index]);

const localizeLink = (match, _label, id, tools) => {
  const tool = tools.find(item => item.id === id);
  return tool ? `[@${tool.title}](tool://${tool.id})` : match;
};

const rewriteAliases = (text, tools) => {
  let current = text;

  replacementsFor(tools).forEach(({ id, alias }) => {
    const tool = tools.find(item => item.id === id);
    if (!tool) return;

    const { parked, tokens } = parkLinks(current);
    const pattern = new RegExp(
      `${BOUNDARY}@${escapeRegExp(alias)}${AFTER}`,
      'gi'
    );
    current = unparkLinks(
      parked.replace(pattern, `$1[@${tool.title}](tool://${id})`),
      tokens
    );
  });

  return current;
};

export const hydrateArrowsAiToolMentions = (text, tools = []) => {
  if (!text) return text;

  return rewriteAliases(text, tools).replace(
    linkPattern(),
    (match, label, id) => localizeLink(match, label, id, tools)
  );
};

export const serializeArrowsAiToolMentions = text => {
  if (!text) return text;

  return text.replace(linkPattern(), (_match, _label, id) => `@${id}`);
};

export const displayArrowsAiToolMentions = text => {
  if (!text) return text;

  return text.replace(
    linkPattern(),
    (_match, label, id) => `@${String(label || '').replace(/^@/, '') || id}`
  );
};
